import React from "react";
import { Grid, Modal, PlainButton, Thumbnail } from "@culturehq/components";

import { Trans } from "app/utils";

import UserName from "components/common/UserName";
import ChqModal from "components/common/ChqModal";
import getUserName from "app/utils/getUserName";

const RecognizedAdditional = ({ cap, users }) => {
  const trigger = onTrigger => (
    <PlainButton onClick={onTrigger}>
      +{users.length - cap} other{users.length === (cap + 1) ? "" : "s"}
    </PlainButton>
  );

  return (
    <ChqModal trigger={trigger}>
      <Modal.Heading>
        <Trans>Recognized Users</Trans>
      </Modal.Heading>
      <Modal.Body>
        <Grid>
          {users.map(user => (
            <Grid.Item key={user.id} xs={6}>
              <UserName user={user} />
            </Grid.Item>
          ))}
        </Grid>
      </Modal.Body>
    </ChqModal>
  );
};

const RecognizedUserList = ({ cap, users }) => (
  <>
    <span className="recognitions__heads">
      {users.slice(0, cap).map(user => (
        <Thumbnail
          key={`user-${user.id}`}
          className="Thumbnail"
          image={user.avatar.thumbUrl}
          title={getUserName(user)}
        />
      ))}
    </span>
    {users.length > cap && (
      <RecognizedAdditional cap={cap} users={users} />
    )}
  </>
);

export default RecognizedUserList;
